import { Button, Table } from "antd";
import moment from "moment";
import { PlusOutlined } from "@ant-design/icons"
import AddSpend from "../components/spend/AddSpend";
import { useEffect, useState } from "react";
import { getData } from "../helpers/api";
import { useSearchParams } from "react-router-dom";
const Spend = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const page = parseInt(searchParams.get("page")) || 1;
    const limit = parseInt(searchParams.get("limit")) || 10;
    const [pagination, setPagination] = useState({
        current: page,
        pageSize: limit,
        total: 0,
    });
    const [spends, setSpends] = useState([])
    const columns = [
        {
            title: "Mentant",
            dataIndex: "paymentAmount",
            key: "paymentAmount",
        },
        {
            title: "Produit",
            dataIndex: "productName",
            key: "productName",
        },
        {
            title: "Prefix d'employee",
            dataIndex: "prefix",
            key: "prefix",
        },
        {
            title: "Date de paiment",
            dataIndex: "paymentDate",
            key: "paymentDate",
            render: (text) => <div>{moment(text).format('YYYY-MM-DD')}</div>
        },
    ]

    const getSpends = async (page = 1, limit = 10) => {
        try {
            const response = await getData('/spend')
            const { spend, total } = response.data
            setPagination({
                current: page,
                pageSize: limit,
                total: total || 0,
            });
            setSpends(spend.map((el)=>({
                id: el.id,
                paymentDate: moment(el.paymentDate).format('YYYY-MM-DD'),
                productName: el.product.name,
                prefix: el.user?.prefix || '-',
                paymentAmount: el.paymentAmount,
            })))

        } catch (error) {
            console.error("Error fetching spends:", error);
        }
    }

    useEffect(() => {
        getSpends(page, limit);
    }, [page, limit]);


    const handleTableChange = (pagination) => {
        const newPage = pagination.current;
        const newLimit = pagination.pageSize;
        setSearchParams({ page: newPage, limit: newLimit });
    };

    return (
        <>
            <div
                style={{
                    display: "flex",
                    textAlign: "center",
                    justifyContent: "flex-end",
                    padding: "10px"
                }}
            >
                <Button
                    onClick={() => { setIsOpen(true) }}
                >
                    <PlusOutlined
                        style={{
                            fontSize: "20px",
                            cursor: "pointer"
                        }}
                    />
                </Button>
            </div>
            <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                <Table
                    columns={columns}
                    dataSource={spends}
                    rowKey={(record) => record.id}
                    pagination={pagination}
                    onChange={handleTableChange}
                />
            </div>
            {isOpen && <AddSpend isOpen={isOpen} closeModal={() => setIsOpen(false)} />}
        </>
    )
}
export default Spend;